// deps
import React, { ReactElement, memo, ReactNode } from "react";

// components
import CommonHeaderV2 from "./HeaderV2";
import SimpleHeader from "./SimpleHeader";

interface CommonHeaderProps {
    children: ReactNode;
    onBack?: VoidFunction;
    containerClass?: string;
    isVisible: boolean;
    isPageScrolled?: boolean;
    showAddressWidgetTop?: boolean;
    isEmptyCart: boolean;
    useHeaderV2?: boolean;
}

function CommonHeader(props: CommonHeaderProps): ReactElement {
    if (props.useHeaderV2) {
        return <CommonHeaderV2 {...props} />;
    }

    return <SimpleHeader {...props} />;
}

export default memo(CommonHeader);
